import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Dialog from "../../atoms/dialog";
import { getDetailsFromUrl } from '../../../services/blueprint';
import BlueprintBuildTabs from '../../tabs/BlueprintBuild';

export default function BuildAlert({ onClose, logType}) {

    const button = <Button id={'close-build-log'} onClick={onClose} style={{textTransform: 'capitalize'}} variant="contained">Close</Button>;
    const {screen} =  getDetailsFromUrl();
    const browserTabTitle = screen == "teams" ? "Team" : screen == "assets" ? "Assets" : screen == "system-model" ?  "System Model" : screen == "transaction" ? "Transaction" : screen == "testsuite" ? "Simulation" : screen == "view" ? "View" : "Blueprint" ;
    
    
    return (
        <Dialog
            container_id={"blueprint_logs_container"}
            title={  logType === 'build' ? 'Build Logs' : 'Deploy Logs'}
            handleClose={() => onClose()}
            open={true}
            paperProps={{ style: { width: 1500, maxWidth: 1500 }, id: "simulationLogsDialog" }}
            actions={button}
        >

        <BlueprintBuildTabs  browserTabTitle={browserTabTitle} logType={logType}/> 

        </Dialog>
    )

}